/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Subject_LabelInputs */



/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Feedback_Subject_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_subject_label = /** @type {((inputs?: Feedback_Subject_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Subject_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sujet")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asunto")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Assunto")
	if (locale === "it") return /** @type {LocalizedString} */ ("Oggetto")
	return /** @type {LocalizedString} */ ("Subject")
});